import { BetType as BetTypeEnum } from '../../../models/games/thaiHiLo/BetType';
export const isOppositeBetting = (
    betType: number,
    betsSummary: Array<number>
): boolean => {
    if (betsSummary === undefined) {
        return false;
    }
    let oppositeType = -1;
    switch (betType) {
        case BetTypeEnum.THLBHi:
            oppositeType = BetTypeEnum.THLBLo;
            break;
        case BetTypeEnum.THLBLo:
            oppositeType = BetTypeEnum.THLBHi;
            break;
    }

    if (oppositeType < 0) {
        return false;
    }    
    return (
        betsSummary[oppositeType] != undefined && betsSummary[oppositeType] > 0
    );
}